import React from 'react';

const SGClinicAssistSection = ({ clinic, editedClinic, setEditedClinic, isEditing }) => {
  const settings = isEditing ? editedClinic?.settings : clinic?.settings;
  const sgClinicAssist = settings?.integration?.sg_clinic_assist;

  console.log('SGClinicAssistSection - isEditing:', isEditing);
  console.log('SGClinicAssistSection - settings:', settings);
  console.log('SGClinicAssistSection - sgClinicAssist:', sgClinicAssist);

  const handleSGClinicAssistChange = (field, value) => {
    if (!isEditing) return;

    setEditedClinic(prev => ({
      ...prev,
      settings: {
        ...prev.settings || {},
        integration: {
          ...prev.settings?.integration || {},
          sg_clinic_assist: {
            ...prev.settings?.integration?.sg_clinic_assist || {},
            [field]: value
          }
        }
      }
    }));
  };

  if (!isEditing) {
    // Read-only view
    return (
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h4 className="text-md font-semibold mb-4">SG Clinic Assist Integration</h4>

        {sgClinicAssist?.enabled ? (
          <div className="space-y-3">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Client ID</label>
                <p className="text-sm text-gray-900 mt-1">{sgClinicAssist.client_id || '-'}</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Organization ID</label>
                <p className="text-sm text-gray-900 mt-1">{sgClinicAssist.organization_id || '-'}</p>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">API Key</label>
              <p className="text-sm text-gray-900 mt-1">
                {sgClinicAssist.api_key ? '••••••••••••••••' : '-'}
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">HCI Code</label>
              <p className="text-sm text-gray-900 mt-1">{sgClinicAssist.hci_code || '-'}</p>
            </div>
          </div>
        ) : (
          <p className="text-gray-500">SG Clinic Assist integration is not enabled.</p>
        )}
      </div>
    );
  }

  // Edit mode
  return (
    <div className="mt-6 pt-6 border-t border-gray-200">
      <h4 className="text-md font-semibold mb-4">SG Clinic Assist Integration</h4>

      <div className="flex items-start space-x-4 mb-4">
        <div className="flex items-center h-5">
          <input
            id="sg_clinic_assist_enabled"
            name="sg_clinic_assist_enabled"
            type="checkbox"
            checked={sgClinicAssist?.enabled || false}
            onChange={(e) => handleSGClinicAssistChange('enabled', e.target.checked)}
            className="h-4 w-4 text-blue-600 border-gray-300 rounded"
          />
        </div>
        <div className="ml-3 text-sm">
          <label htmlFor="sg_clinic_assist_enabled" className="font-medium text-gray-700">
            Enable SG Clinic Assist Integration
          </label>
          <p className="text-gray-500">
            When enabled, the system will integrate with the Singapore Clinic Assistant API for enhanced functionality.
          </p>
        </div>
      </div>

      {sgClinicAssist?.enabled && (
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Client ID
              </label>
              <input
                type="text"
                value={sgClinicAssist?.client_id || ''}
                onChange={(e) => handleSGClinicAssistChange('client_id', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="Enter client ID"
              />
              <p className="mt-1 text-xs text-gray-500">
                The client identifier for the SG Clinic Assist API.
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Organization ID
              </label>
              <input
                type="text"
                value={sgClinicAssist?.organization_id || ''}
                onChange={(e) => handleSGClinicAssistChange('organization_id', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="Enter organization ID"
              />
              <p className="mt-1 text-xs text-gray-500">
                The organization identifier for the SG Clinic Assist API.
              </p>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              API Key
            </label>
            <input
              type="password"
              value={sgClinicAssist?.api_key || ''}
              onChange={(e) => handleSGClinicAssistChange('api_key', e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter API key"
            />
            <p className="mt-1 text-xs text-gray-500">
              The API key for authenticating with the SG Clinic Assist API.
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              HCI Code
            </label>
            <input
              type="text"
              value={sgClinicAssist?.hci_code || ''}
              onChange={(e) => handleSGClinicAssistChange('hci_code', e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter HCI code"
            />
            <p className="mt-1 text-xs text-gray-500">
              The Healthcare Institution (HCI) code for the clinic.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SGClinicAssistSection;
